<template>
  <button
    class="
      bg-white
      text-black
      text-sm
      shadow
      hover:shadow-none
      hover:text-black
      font-bold
      py-2
      px-4
      border-solid
      border-2
      border-white
      cursor-pointer
      press-down
      border-box
      "
    @click="click"
  >
    <i v-if="icon" :class="icon"></i> {{ text }}
  </button>
</template>

<script>
export default {
  name: 'Button',
  props: [
    'text',
    'click',
    'icon',
  ],
};
</script>

<style lang="scss">
.press-down {
  outline: none;
  transition: all .3 linear;
  transform: translateY(-2px);
  &:active {
    transform: translateY(0);
    box-shadow: none;
  }
}
</style>
